import { render, staticRenderFns } from "./groupList.vue?vue&type=template&id=2e5ef429&scoped=true&"
import script from "./groupList.vue?vue&type=script&lang=js&"
export * from "./groupList.vue?vue&type=script&lang=js&"
import style0 from "./groupList.vue?vue&type=style&index=0&id=2e5ef429&prod&lang=scss&"
import style1 from "./groupList.vue?vue&type=style&index=1&id=2e5ef429&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5ef429",
  null
  
)

export default component.exports